import React, { FC } from "react";
import { getLeadsFormFileUploadSubfolder } from "repoV2/utils/getInTouchForm/getInTouchForm.utils";

import { IListing } from "repoV2/features/Listing/Listing.interfaces";
import {
    CUSTOM_QUESTION_TYPES,
    CUSTOM_QUESTION_TYPES_ID,
} from "../../../../../../repoV2/utils/getInTouchForm/getInTouchForm.constants";
import styles from "../../ExpressInterest/expressInterest.module.scss";
import { IExpressInterestCustomQuestions } from "../IExpressInterestCustomQuestions";

const QuestionInput: FC<
    IExpressInterestCustomQuestions.IBaseFieldProps & {
        item: IListing.IQuestion;
    }
> = props => {
    const localProps = { ...props };

    // https://eslint.org/docs/latest/rules/no-param-reassign
    const { item } = localProps;

    if (!CUSTOM_QUESTION_TYPES[item.type]) return null;

    if (item.type === CUSTOM_QUESTION_TYPES_ID.FILE) {
        localProps.subFolder = getLeadsFormFileUploadSubfolder();
        localProps.usedIn = "eventPageSidebar";
    }

    return (
        <div key={item.uuid} className={styles.formField}>
            <div
                className={styles.formTitle}
                title={`This field is ${
                    item.is_mandatory ? "mandatory" : "optional"
                }`}
            >
                {item.question}
                {item.is_mandatory ? (
                    <span className={styles.mandatory}>&nbsp;*</span>
                ) : null}
            </div>
            {CUSTOM_QUESTION_TYPES[item.type].renderQuestion(localProps)}
        </div>
    );
};

export default QuestionInput;
